import { useEffect, useState } from "react";
import { panic } from "./panic";

export const usePanicEnabled = () => {
  const [v, setV] = useState(panic.isEnabled());
  useEffect(() => panic.subscribe(setV), []);
  return [v, panic.setEnabled.bind(panic)];
};
